module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00358.b2e71460.jpg";